import type { PlaceDetail } from '@consumer/types/serializers'
import { injectionKey } from '@shared/injection'

export const primaryPlaceInjectionKey = injectionKey<Ref<PlaceDetail | undefined>>('primaryPlace')

export function usePrimaryPlace () {
  return inject(primaryPlaceInjectionKey, toRef(undefined))
}
